import React, { useContext, useMemo } from 'react';
import { ApolloError } from '@apollo/client';
import { remapApolloErrors } from '../../../../helpers/remapApolloErrors';
import { showToast } from '../../../../helpers/showToast';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { Modal } from '../../../../components/containers/Modal';
import { BoxNotification } from '../../../../components/containers/BoxNotification';
import { TreeMenuContext } from '../TreeMenu/TreeMenuProvider';
import classes from './DeleteFolderModal.module.scss';

export type DeleteFolderModalProps = {
  deleteFolderHandler: CallableFunction;
};

export const DeleteFolderModalView = (props: DeleteFolderModalProps): JSX.Element => {
  const { deleteFolderHandler } = props;
  const { selectedMenuItem, closeHandler } = useContext(TreeMenuContext);

  const modalProps = useMemo(
    () => ({
      showCloseIcon: true,
      title: `Delete Folder`,
      onClose: closeHandler,
      loading: false,
      primaryButtonAction: () => {
        deleteFolderHandler(selectedMenuItem?.id)
          .catch((error: ApolloError) => {
            const mappedError = remapApolloErrors(error);
            showToast({
              summary: 'Error deleting the folder',
              detail: mappedError,
              severity: 'error'
            });
          })
          .finally(() => {
            closeHandler();
          });
      },
      primaryButtonTitle: 'Delete Folder',
      primaryButtonColor: ButtonColorsEnum.alert
    }),
    [closeHandler, deleteFolderHandler, selectedMenuItem]
  );

  return (
    <Modal {...modalProps}>
      <div>
        Are you sure you want to delete <span className={classes.NameFolder}>{selectedMenuItem?.name}</span>?
      </div>
      <BoxNotification type={'error'}>If deleted, we will stop importing posts from all sources.</BoxNotification>
    </Modal>
  );
};
